import { useContext } from 'react';
import { MerchantContext } from '../contexts/MerchantContextCore';

export function useMerchant() {
    const context = useContext(MerchantContext);
    if (context === undefined) {
        throw new Error('useMerchant must be used within a MerchantProvider');
    }
    return context;
}
